import { render, staticRenderFns } from "./DragDropExcel.vue?vue&type=template&id=36d83f4e"
import script from "./DragDropExcel.vue?vue&type=script&lang=js"
export * from "./DragDropExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports